import { Link } from "@nextui-org/link";
import {
  Navbar as NextUINavbar,
  NavbarBrand,
  NavbarContent,
  NavbarItem,
  NavbarMenuToggle,
  NavbarMenu,
} from "@nextui-org/navbar";
import { link as linkStyles } from "@nextui-org/theme";
import clsx from "clsx";
import { Tooltip } from "@nextui-org/tooltip";
import { ScrollShadow } from "@nextui-org/scroll-shadow";

import React, { useEffect, useState } from "react";
import { Input } from "@nextui-org/input";

// import Settings from "./settings";
import {
  
  SettingsIcon,
  ShoppingBag,
  User2,
  UserIcon,
  WalletMinimal,
} from "lucide-react";
import { Button } from "@nextui-org/button";

import StreamList from "./streamList";
import CreateSource from "./createSource";
import ConfigPage from "./adminConfig";
import Payament from "./payament";
import Invoices from "./invoiceList";
import AccountSettings from "./accountSettings";

import { siteConfig } from "@/config/site";
import { ThemeSwitch } from "@/components/theme-switch";
import { Logo } from "@/components/icons";
import useAppStore from "@/store/store";
import { Channel } from "@/proivder/channelProvider";
import { AuthProvider } from "@/proivder/authProvider";

import Login from "./login";
import { TokenProvider } from "@/proivder/tokenProvider";
import { base64ToJson } from "@/lib/base64";
import { version } from "../../package.json";

import { Chip } from "@nextui-org/chip";
import { useLocation, useNavigate } from "react-router-dom";
import { Badge } from "@nextui-org/badge";

export const Navbar = () => {
  const channels = useAppStore((v) => v.channels);
  const channel = useAppStore((v) => v.channel);
  const player = useAppStore((v) => v.videoPlayer);

  const reloadVideo = useAppStore((v) => v.reloadVideo);

  const setChannel = useAppStore((v) => v.setChannel);

  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const userRoles = useAppStore((v) => v.userRoles);

  const [keyword, setKeyword] = React.useState("");

  const [, setIsOpen] = useState(false);

  const [updateSource, setUpdateSource] = useState<Channel | null>(null);

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const isLoginRequired = useAppStore((v) => v.loginRequired);
  const setIsLoginRequired = useAppStore((v) => v.setLoginRequired);

  const [isPremiumOpenend, setIsPremiumOpenend] = useState(false);
  const [isLoginOpenend, setIsLoginOpenend] = useState(false);
  const [isInvoicesOpenend, setIsInvoicesOpenend] = useState(false);
  const [isAccountSettingsOpenend, setIsAccountSettingsOpenend] =
    useState(false);

  const [isAdminOpenend, setIsAdminOpenend] = useState(false);

  const setLoggedIn = useAppStore((v) => v.setLoggedIn);

  const getRoles = useAppStore((v) => v.getRoles);

  const setBasketItems = useAppStore((v) => v.setBasketItems);
  const basketItems = useAppStore((v) => v.basketItems);

  function handleUpdateSource(channel: Channel | null) {
    setUpdateSource(channel);
  }
  const navigte = useNavigate();
  const location = useLocation();

  function handleCheckAuthentication() {
    // setIsLoggedIn(!!authProvider.userIsLoggedIn);

    // check url has session_state query param

    if (window.location.search.includes("session_state")) {
      const authProvider = AuthProvider.getInstance();

      authProvider.onAuthentificationChange((isLoggedIn) => {
        setIsLoggedIn(isLoggedIn);
        // remove session_state query param
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        );
        getRoles();
        setLoggedIn(isLoggedIn);
        reloadVideo();
      });
    }

    const token = TokenProvider.getToken();

    if (token) {
      setIsLoggedIn(true);
      setLoggedIn(true);

      //
      const userId = base64ToJson(token);

      if (userId) {
        useAppStore.setState({ userId });
      }

      getRoles();
      reloadVideo();
    } else {
      setIsLoggedIn(false);
      setLoggedIn(false);
    }

    // scroll to top
    window.scrollTo(0, 0);
  }

  useEffect(() => {
    handleCheckAuthentication();

    const savedBasket = localStorage.getItem("basket");

    if (savedBasket) {
      setBasketItems(JSON.parse(savedBasket));
    }
  }, []);

  useEffect(() => {
    if (isLoginRequired) {
      setIsMenuOpen(true);
      setIsLoginOpenend(true);
      setIsLoginRequired(false);
    }
  }, [isLoginRequired]);
  const isMobile = window.innerWidth <= 640;

  return (
    <NextUINavbar
      isMenuOpen={isMenuOpen}
      maxWidth="xl"
      position="sticky"
      onMenuOpenChange={(v) => {
        setIsMenuOpen(v);
        if (!v) {
          setIsPremiumOpenend(false);
          setIsLoginOpenend(false);
          setIsAdminOpenend(false);
          setIsAccountSettingsOpenend(false);
          setIsInvoicesOpenend(false);
          window.scrollTo(0, 0);
        }
      }}
    >
      <NavbarContent className="basis-1/5 sm:basis-full" justify="start">
        <NavbarBrand className="gap-3 max-w-fit">
          <Link
            className="flex justify-start items-center gap-2"
            color="foreground"
            href="/"
          >
            <Logo />
            <p className="font-bold text-lg">EMS BT</p>
            <p className=" text-xs"> {version} </p>
          </Link>
        </NavbarBrand>

        {isLoggedIn && (
          <NavbarItem className=" flex pl-6 items-center">
            <Tooltip content="View Your Credits">
              <Chip
                startContent={<WalletMinimal size={18} />}
                variant="faded"
                color="success"
                className="cursor-pointer"
                size={isMobile ? "sm" : "md"}
                onClick={() => {
                  navigte("/settings?tab=credits");
                }}
              >
                <span className=" font-semibold text-sm"> 546</span>
              </Chip>
            </Tooltip>
          </NavbarItem>
        )}
      </NavbarContent>

      <NavbarContent
        className="hidden sm:flex basis-1/5 sm:basis-full"
        justify="end"
      >
        <NavbarItem className=" mx-2">
          {!isMobile && location.pathname === "/" && (
            <CreateSource
              editItem={updateSource}
              onCreated={() => setIsOpen(false)}
              onUpdate={() => handleUpdateSource(null)}
            />
          )}
        </NavbarItem>

        <NavbarItem className="hidden sm:flex gap-4 items-center">
          {userRoles.includes("admin") ? (
            <Tooltip content="Admin Configuration">
              <Button
                isIconOnly
                size="sm"
                onClick={() => {
                  setIsMenuOpen(true);
                  setIsAdminOpenend(true);
                }}
              >
                <SettingsIcon size={18} />
              </Button>
            </Tooltip>
          ) : null}

          {!userRoles.includes("admin") ? (
            <NavbarMenuToggle
              icon={
                <Badge
                  color="primary"
                  placement="top-left"
                  isInvisible={basketItems.length < 1 || !isLoggedIn}
                  content={basketItems.length}
                >
                  <Tooltip content="Cart">
                    <Button
                      isIconOnly
                      size="sm"
                      onClick={() => {
                        // check if user is logged in
                        if (!isLoggedIn) {
                          setIsMenuOpen(true);
                          setIsLoginOpenend(true);
                          return;
                        }
                        // setIsMenuOpen(true);
                        setIsAccountSettingsOpenend(false);
                        setIsInvoicesOpenend(false);
                        // setIsPremiumOpenend(true);
                        navigte("/settings?tab=cart");
                      }}
                    >
                      <ShoppingBag size={18} />
                    </Button>
                  </Tooltip>
                </Badge>
              }
            />
          ) : null}

          {isLoggedIn ? (
            <Tooltip content="Account">
              <Button
                onClick={() => {
                  // const authProvider = AuthProvider.getInstance();
                  // authProvider.logout();
                  // setLoggedIn(false);

                  // setIsMenuOpen(true);
                  setIsInvoicesOpenend(false);
                  // setIsAccountSettingsOpenend(true);
                  navigte("/settings");
                }}
                isIconOnly
                size="sm"
              >
                <User2 size={18} />
              </Button>
            </Tooltip>
          ) : (
            <NavbarMenuToggle
              icon={
                <Tooltip content="Login">
                  <Button
                    onClick={() => {
                      setIsMenuOpen(true);
                      setIsLoginOpenend(true);
                    }}
                    isIconOnly
                    size="sm"
                  >
                    <UserIcon size={18} />
                  </Button>
                </Tooltip>
              }
            />
          )}

          {/* <div className="hidden lg:flex  justify-end mr-1">
            {siteConfig.navItems.map((item) => (
              <Tooltip key={item.href} content="About Us">
                <Link
                  key={item.href}
                  className={clsx(
                    linkStyles({ color: "foreground" }),
                    "data-[active=true]:text-primary data-[active=true]:font-medium"
                  )}
                  color="foreground"
                  href={item.href}
                >
                  {<item.label size={20} />}
                </Link>
              </Tooltip>
            ))}
          </div> */}

          {/* <Settings /> */}
        </NavbarItem>
        <div className=" hidden">
          <ThemeSwitch />
        </div>
        <NavbarMenuToggle />
      </NavbarContent>

      <NavbarContent className="sm:hidden basis-1 pl-4" justify="end">
        {!userRoles.includes("admin") ? (
          <Badge
            color="primary"
            placement="top-left"
            isInvisible={basketItems.length < 1 || !isLoggedIn}
            content={basketItems.length}
          >
            <Tooltip content="Your Cart">
              <Button
                isIconOnly
                size="sm"
                onClick={() => {
                  // setIsMenuOpen(true);
                  setIsAccountSettingsOpenend(false);
                  setIsInvoicesOpenend(false);
                  // setIsPremiumOpenend(true);
                  navigte("/settings?tab=cart");
                }}
              >
                <ShoppingBag size={18} />
              </Button>
            </Tooltip>
          </Badge>
        ) : null}

        {userRoles.includes("admin") ? (
          <Tooltip content="Admin Configuration">
            <Button
              isIconOnly
              size="sm"
              onClick={() => {
                setIsMenuOpen(true);

                setIsAdminOpenend(true);
              }}
            >
              <SettingsIcon size={18} />
            </Button>
          </Tooltip>
        ) : null}

        {isLoggedIn ? (
          <Tooltip content="Account">
            <Button
              onClick={() => {
                //  const authProvider = AuthProvider.getInstance();

                //  authProvider.logout();
                // setIsMenuOpen(true);
                setIsInvoicesOpenend(false);
                setIsPremiumOpenend(false);
                // setIsAccountSettingsOpenend(true);
                navigte("/settings");
              }}
              isIconOnly
              size="sm"
            >
              <User2 size={18} />
            </Button>
          </Tooltip>
        ) : (
          <NavbarMenuToggle
            icon={
              <Tooltip content="Login">
                <Button
                  onClick={() => {
                    setIsMenuOpen(true);
                    setIsLoginOpenend(true);
                  }}
                  isIconOnly
                  size="sm"
                >
                  <UserIcon size={18} />
                </Button>
              </Tooltip>
            }
          />
        )}

        {/* <Settings /> */}
        <NavbarMenuToggle />
      </NavbarContent>

      <NavbarMenu>
        {isInvoicesOpenend ? (
          <Invoices />
        ) : isAccountSettingsOpenend ? (
          <AccountSettings
            onUpgrade={() => {
              setIsAccountSettingsOpenend(false);
              setIsMenuOpen(true);
              setIsPremiumOpenend(true);
            }}
            onInvoices={() => {
              setIsAccountSettingsOpenend(false);
              setIsInvoicesOpenend(true);
            }}
            onLogout={() => {
              const authProvider = AuthProvider.getInstance();

              authProvider.logout();
              setLoggedIn(false);
              setIsMenuOpen(false);
            }}
          />
        ) : isAdminOpenend ? (
          <ConfigPage />
        ) : isLoginOpenend ? (
          <Login
            onClose={() => {
              setIsMenuOpen(false);
              setIsPremiumOpenend(false);
              handleCheckAuthentication();
              setIsLoginOpenend(false);
              setIsAccountSettingsOpenend(false);
              setIsInvoicesOpenend(false);
            }}
          />
        ) : isPremiumOpenend ? (
          <Payament />
        ) : (
          <div className="mt-2 flex flex-col gap-2 justify-center">
            <div className=" gap-2 mb-2 flex-row-reverse container mx-auto max-w-6xl flex">
              <ThemeSwitch />

              <div className="flex  justify-end mr-1">
                {siteConfig.navItems.map((item) => (
                  <Tooltip key={item.href} content="About Us">
                    <Link
                      key={item.href}
                      className={clsx(
                        linkStyles({ color: "foreground" }),
                        "data-[active=true]:text-primary data-[active=true]:font-medium"
                      )}
                      color="foreground"
                      href={item.href}
                    >
                      {<item.label size={20} />}
                    </Link>
                  </Tooltip>
                ))}
              </div>
            </div>
            <Input
              className="w-full"
              placeholder="Search"
              value={keyword}
              onChange={(v) => setKeyword(v.target.value)}
            />
            <ScrollShadow className="flex-grow overflow-scroll scrollbar-hide w-full justify-center">
              <StreamList
                channel={channel!}
                items={channels.filter((c) =>
                  c.name.toLowerCase().includes(keyword.toLowerCase())
                )}
                videoPlayer={player!}
                onChannel={(c) => setChannel(c)}
                onDelete={() => null}
                onExport={() => null}
                onPlay={() => setIsMenuOpen(false)}
                onUpdate={() => null}
              />
            </ScrollShadow>
          </div>
        )}
      </NavbarMenu>
    </NextUINavbar>
  );
};
